import { cn } from "@/lib/utils";

interface KickerProps {
  children: React.ReactNode;
  className?: string;
  as?: "div" | "h2" | "h3";
}

/**
 * Section label — sentence case, 13px medium, muted. Labels a block of
 * content ("Top findings", "Why it matters"); not a headline.
 */
export function Kicker({ children, className, as: Tag = "div" }: KickerProps) {
  return (
    <Tag className={cn("text-sm font-medium text-muted-foreground", className)}>
      {children}
    </Tag>
  );
}
